{
  "quiz": {
    "takeQuiz": "Gör quiz",
    "generating": "Skapar quiz...",
    "generationFailed": "Quizet kunde inte skapas. Försök igen.",
    "ready": "Ditt quiz är klart.",
    "progress": "{{current}} av {{total}}",
    "incorrect": "Inte riktigt. Prova ett annat alternativ.",
    "reasonHeading": "Rätt",
    "next": "Nästa",
    "doneTitle": "Quiz genomfört",
    "doneDescription": "Du svarade rätt på alla frågor.",
    "takeAgain": "Gör om"
  }
}
